export const SigviewViews = {
  CPREF: 'CPREF',
  INVENTORY_DISCOVERY: 'Inventory_Discovery',
} as const;
